module.exports = __webpack_public_path__ + "static/media/COS_VALWIN.78eb1939.png";